import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import AsyncFeedback from 'components/AsyncFeedback/AsyncFeedback';
import {
  createValidator,
  googleAnalyticsId as googleAnalyticsValidation,
  googleTagManagerId as googleTagManagerValidation,
  facebookPixelId as facebookPixelIdValidation,
} from 'utils/validation';
import { Button } from '@storable/canaveral-components';
import { MANAGE } from '../../../../../../modules/authorization/actions';
import { BUILDER, SEO_ANALYTICS } from '../../../../../../modules/authorization/subjects';
import Form from '../../../../../../modules/react/components/stateful/Form';
import Input from '../../../../../../modules/react/components/stateful/Input';
import Field from '../../../../../../modules/react/components/stateful/Field';
import useCurrentUser from '../../../../../../admin/hooks/useCurrentUser';
import style from './AnalyticsSettings.scss';

const propTypes = {
  facebookPixelId: PropTypes.string,
  googleAnalyticsId: PropTypes.string,
  googleTagManagerId: PropTypes.string,
  error: PropTypes.string,
  isSaving: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
};

const defaultProps = {};

const contextTypes = {
  setTab: PropTypes.func.isRequired,
};

const AnalyticsSettings = ({
  facebookPixelId,
  googleAnalyticsId,
  googleTagManagerId,
  onSave,
  isSaving,
  error,
}, context) => {
  const currentUser = useCurrentUser();
  const authSEOAnalytics = currentUser.can(MANAGE, BUILDER, SEO_ANALYTICS);

  useEffect(() => () => context.setTab('settings/analytics'), [context]);

  const handleSubmit = (data) => {
    onSave(data);
  };

  return (
    <div>
      <AsyncFeedback
        isSaving={isSaving}
        success="Your changes have been saved."
        error={error}
      />
      <Form
        form="tag manager"
        onSubmit={handleSubmit}
        initialValues={{ googleTagManagerId, googleAnalyticsId, facebookPixelId }}
        onlyValidateOnSubmit
        validate={createValidator({
          googleAnalyticsId: googleAnalyticsValidation,
          googleTagManagerId: googleTagManagerValidation,
          facebookPixelId: facebookPixelIdValidation,
        })}
      >
        <Field
          className={style.inputAnalytics}
          label="Google Tag Manager ID"
          groupClassName={style.heading}
          name="googleTagManagerId"
          maxLength="20"
          component={Input}
          help={<span className="text-secondary">Starts with <code>GTM-</code></span>}
          disabled={!authSEOAnalytics}
        />
        <Field
          className={style.inputAnalytics}
          label="Google Analytics ID"
          groupClassName={style.heading}
          name="googleAnalyticsId"
          maxLength="15"
          component={Input}
          help={<span className="text-secondary">Starts with <code>UA-</code></span>}
          disabled={!authSEOAnalytics}
        />
        <Field
          className={style.inputAnalytics}
          label="Facebook Pixel ID"
          groupClassName={style.heading}
          name="facebookPixelId"
          maxLength="16"
          minLength="15"
          component={Input}
          help={<span className="text-secondary">This is a 15 or 16 digit code</span>}
          disabled={!authSEOAnalytics}
        />
        {authSEOAnalytics && (
          <Button
            type="submit"
            context="positive"
            disabled={isSaving}
          >
            Save
          </Button>
        )}
      </Form>
    </div>
  );
};

AnalyticsSettings.propTypes = propTypes;
AnalyticsSettings.defaultProps = defaultProps;
AnalyticsSettings.contextTypes = contextTypes;

export default AnalyticsSettings;
